<template>
  <div class="c-home-masthead">
    <div class="c-home-masthead__headlines">
      <sc-text tag="h1" v-if="fields && fields.heading" :field="fields.heading" />
      <sc-text tag="h2" v-if="fields && fields.subheading" :field="fields.subheading" />
    </div>
    <div class="c-home-masthead__gradient">
      <div class="c-home-masthead__features">
        <div class="left">
          <sc-placeholder name="jss-home-masthead-left" :rendering="rendering" />
        </div>
        <div class="right">
          <sc-placeholder name="jss-home-masthead-right" :rendering="rendering" />
        </div>
        <div class="bottom">
          <sc-placeholder name="jss-home-masthead-update" :rendering="rendering" />
        </div>
      </div>
      <sc-placeholder name="jss-home-masthead-bottom" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Home-Masthead',
  components: {
    ScText: Text,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.c-home-masthead {
  margin-top: 4rem;

  &__headlines {
    @include padding-x-thin;

    h1,
    h2 {
      @include large-desktop-up {
        padding-right: 10%;
      }
    }
  }

  &__gradient {
    @include padding-y(0, 4rem);
    color: $white;
    background: linear-gradient(
      169deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 59, 92, 1) 20%,
      rgba(0, 134, 191, 1) 100%
    );
    margin-top: 2.8rem;

    @include tablet-up {
      @include padding-y(0, 6rem);
    }
  }

  &__features {
    @include padding-x-thin;

    @include desktop-up {
      display: flex;
      flex-wrap: wrap;
      margin-top: 4rem;
    }

    .left {
      @include tablet-up {
        display: flex;
      }

      @include desktop-up {
        width: 75%;
        margin-right: 1.2rem;
        margin-bottom: 2rem;
      }
    }

    .right {
      @include desktop-up {
        display: flex;
        flex-direction: column;
        width: calc(25% - 1.2rem);
        margin-bottom: 2rem;
      }
    }

    .bottom {
      flex-basis: 100%;
    }
  }
}
</style>
